import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(ITaskManagementAccessor, 'ITaskManagementAccessor');
//endregion
function ITaskManagementAccessor() {
}
//region block: exports
export {
  ITaskManagementAccessor as ITaskManagementAccessor3mgawdm8ty2sh,
};
//endregion

